import { useContext } from "react";
import { CartContext } from "./CartContext.tsx";
import type { CartContextType } from "./cartContext";

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    console.error("[CartContext] useCart() context is undefined. This means CartProvider is missing or duplicated module instance.", {
      CartContext,
    });
    throw new Error("useCart must be used within a CartProvider");
  }
  return context;
};
